import { LAYOUTS } from "./layouts";

/**
 * Dynamic proposal data — the ONLY content an employee can change.
 * Everything else (copy, photos, layout, typography) lives in the fixed
 * template components under src/proposals/document/pages.
 *
 * ProposalData = {
 *   recipientName: string,
 *   artworks: [{ id, layout, caption, description (layout "option"), slots: [{ image, crop: { zoom, x, y } }] }],
 *   project: { name, description, photo: slot, artType, artTypeDescription, arrangement: slot },
 *   price: { project, location, phone, date, quoteNumber, validUntil,
 *            items: [{ id, description, frame, dimensions, quantity, unitPrice }],
 *            designFee, deliveryFee, siteVisitFee, discount,
 *            installationFee, hideDeliveryFee (from a project invoice only) },
 * invoiceLink = { invoiceId, versionId, invoiceNumber } - proposal of a project invoice
 *   (server-managed, see fromInvoice.js)
 * }
 * image = { src (Firebase Storage URL), width, height, name, storagePath } | null
 *
 * Saved by the backend in the "artikaProposals" collection
 * (artika-backend/controllers/proposalController.js).
 */

let counter = 0;
export const uid = (prefix) => `${prefix}-${Date.now().toString(36)}-${(counter++).toString(36)}`;
export const DEFAULT_CROP = { zoom: 1, x: 0.5, y: 0.5 };
const slot = (image, crop = {}) => ({
    image,
    crop: { ...DEFAULT_CROP, ...crop },
});
export const emptyArtworkPage = (layout) => ({
    id: uid("art"),
    layout,
    caption: "",
    description: "",
    source: "manual",
    slots: LAYOUTS[layout].slots.map(() => slot(null)),
});
export const emptyPriceItem = () => ({
    id: uid("item"),
    description: "",
    frame: "",
    dimensions: "",
    quantity: 1,
    unitPrice: 0,
});
export const emptyPriceOffer = () => ({
    project: "",
    location: "",
    phone: "",
    date: "",
    quoteNumber: "",
    validUntil: "",
    items: [emptyPriceItem(), emptyPriceItem(), emptyPriceItem(), emptyPriceItem()],
    designFee: 0,
    deliveryFee: 0,
    siteVisitFee: 0,
    installationFee: 0,
    hideDeliveryFee: false,
    discount: 0,
});
// صفحات «المشروع» و«ترتيب اللوحات المقترح»
export const emptyProject = () => ({
    name: "",
    description: "",
    photo: slot(null),
    artType: "",
    artTypeDescription: "",
    arrangement: slot(null),
});
/** A blank proposal — what "Reset" returns to. */
export const emptyProposal = () => ({
    recipientName: "",
    // إزاحة الشعار و«ارتيكا» بالغلاف (pt) - المدير بس يغيّرها
    coverBrandOffset: 0,
    artworks: [emptyArtworkPage("wall-portrait"), emptyArtworkPage("photo-full")],
    price: emptyPriceOffer(),
    project: emptyProject(),
});
